import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { API_BASE_URL } from "../config/apiBase";
import { buildCurriculumLessonMap, buildNeedsReviewQueue } from "./tutorWorkflowData";
import { getAuthUserHeader } from "../utils/userRoles";

const API = API_BASE_URL;

export default function TutorLandingRedirect() {
  const [target, setTarget] = React.useState("");

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const [dashboardRes, curriculumRes] = await Promise.all([
          fetch(`${API}/tutor/dashboard`, {
            cache: "no-store",
            headers: { "X-User": getAuthUserHeader() },
          }),
          fetch(`${API}/curriculum`, { cache: "no-store" }),
        ]);
        const [dashboardJson, curriculumJson] = await Promise.all([
          dashboardRes.json().catch(() => null),
          curriculumRes.json().catch(() => null),
        ]);
        if (cancelled) return;
        const queue = buildNeedsReviewQueue(
          Array.isArray(dashboardJson?.review_queue) ? dashboardJson.review_queue : [],
          buildCurriculumLessonMap(curriculumJson)
        );
        setTarget(queue.length ? "/tutor/needs-review" : "/tutor/student-progress");
      } catch {
        if (!cancelled) setTarget("/tutor/needs-review");
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!target) {
    return (
      <div style={{ color: "var(--muted)", padding: "24px 0" }}>
        Loading tutor workspace...
      </div>
    );
  }

  return <Navigate to={target} replace />;
}
